import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { SectionLabel } from '../ui/SectionLabel';

export const Leadership = () => (
  <section className="py-28 md:py-40 bg-cream/20 border-y border-gold/10">
    <div className="container mx-auto px-6 md:px-14">
      <FadeIn className="text-center mb-20">
        <SectionLabel>The Visionaries</SectionLabel>
        <h2 className="font-serif text-4xl md:text-5xl text-charcoal">Meet the Leadership</h2>
      </FadeIn>

      <div className="max-w-4xl mx-auto">
        {/* Director Madam Mokhtar */}
        <FadeIn direction="up" delay={0.1}>
          <div className="bg-charcoal text-white p-10 md:p-20 flex flex-col justify-center shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-80 h-80 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-60 h-60 bg-wine/10 rounded-full blur-2xl translate-y-1/2 -translate-x-1/2 pointer-events-none" />
            
            <div className="relative z-10 text-center lg:text-left">
              <h3 className="font-serif text-4xl text-gold mb-2">Madam Mokhtar</h3>
              <p className="text-white/60 text-xs tracking-[0.2em] uppercase font-medium mb-12">Founder & Managing Director</p>
              
              <div className="space-y-8 text-white/80 font-light leading-relaxed text-base md:text-lg italic max-w-3xl mx-auto lg:mx-0">
                <p>
                  "With over 20 years of experience in the food and beverage industry, I specialize in refined bistro and fine dining service and operations. My career has been built on the principles of precision, professionalism, and the pursuit of excellence in every guest experience.
                </p>
                <p>
                  Having worked in renowned dining establishments, I have developed a deep understanding of service etiquette, restaurant management, and staff development. These experiences have shaped a leadership approach that values both the traditions of elevated bistro dining and the innovation that drives modern hospitality.
                </p>
                <p>
                  At Maison De Charm, my goal is to create a dining experience that embodies quality, elegance, and authenticity — where every detail reflects our dedication to the art of hospitality."
                </p>
              </div>
              <div className="mt-14 w-20 h-px bg-gold/40 mx-auto lg:mx-0" />
            </div>
          </div>
        </FadeIn>
      </div>
    </div>
  </section>
);